import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { css } from '@emotion/react';

import { useIllustrationUrl } from '../../components/Illustrations/hooks/useIllustrationUrl.hook';
import { AddPostIllustration } from '../../components/Illustrations/AddPost/AddPost';

import { useIsPricingEditable } from '../../contexts/PricingEditionContext/hooks/useIsPricingEditable.hook';
import { Avatar } from '../Avatar';

import {
  DEFAULT_SERVICE_USAGE_PLACEHOLDER_HEIGHT,
  SERVICE_USAGE_CARD_SIZE,
  SERVICE_USAGE_CARD_SX,
} from './constants/card.constant';

interface Props {
  readonly onStartCreate: () => void;
}

const newServiceUsageString = 'Ajouter une nouvelle prestation';

export const NewServiceUsageCard = ({
  onStartCreate: handleStartCreate,
}: Readonly<Props>) => {
  const imageUrl = useIllustrationUrl(AddPostIllustration);
  const isPricingEditable = useIsPricingEditable();

  return (
    <Grid size={SERVICE_USAGE_CARD_SIZE} sx={SERVICE_USAGE_CARD_SX}>
      <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={
            <Avatar icon={<PlaylistAddIcon />} label={newServiceUsageString} />
          }
          css={css`
            .MuiCardHeader-action {
              display: contents;
            }
          `}
        />
        <CardMedia
          alt={newServiceUsageString}
          component="img"
          height={DEFAULT_SERVICE_USAGE_PLACEHOLDER_HEIGHT}
          image={imageUrl}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography color="text.secondary" variant="body2">
            {newServiceUsageString}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            disabled={!isPricingEditable}
            onClick={handleStartCreate}
            size="medium"
            variant="outlined"
          >
            Formulaire
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};
